// extracted by mini-css-extract-plugin
module.exports = {"text":"tutorial_text__2zKkg"};